export default __webpack_public_path__ + "static/media/guest_15_01.819a3b05.png";